import { render, staticRenderFns } from "./MangeDownloadForms.vue?vue&type=template&id=7600a3e1&"
import script from "./MangeDownloadForms.vue?vue&type=script&lang=js&"
export * from "./MangeDownloadForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports